import { render } from "./CadastrarVisitante.vue?vue&type=template&id=2c899bd8&scoped=true"
import script from "./CadastrarVisitante.vue?vue&type=script&lang=js"
export * from "./CadastrarVisitante.vue?vue&type=script&lang=js"

import "./CadastrarVisitante.vue?vue&type=style&index=0&id=2c899bd8&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c899bd8"]])

export default __exports__